import { Injectable } from '@angular/core';
import { PresetsModel } from '@syncfusion/ej2-calendars';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateRangePresetsService {

  // DateRange
  public today: Date = new Date(new Date().toDateString());
  public weekStart: Date = new Date(new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() + 7) % 7)).toDateString());
  public weekEnd: Date = new Date(new Date(new Date().setDate(new Date(new Date().setDate((new Date().getDate() - (new Date().getDay() + 7) % 7))).getDate() + 6)).toDateString());
  public monthStart: Date = new Date(new Date(new Date().setDate(1)).toDateString());
  public monthEnd: Date = moment().endOf('month').toDate();
  public lastStart: Date = new Date(moment().add('month', -1).toDate().toDateString());
  public lastEnd: Date = this.today;
  public yearStart: Date = new Date(new Date(new Date().setDate(new Date().getDate() - 365)).toDateString());
  public yearEnd: Date = this.today;

  constructor() { }

  defaults: PresetsModel[] = 
      [
      { label: "Essa Semana" ,start: this.weekStart ,end: this.weekEnd },
      { label: "Esse Mês" ,start: this.monthStart ,end: this.monthEnd },
      { label: "Último Mês", start: this.lastStart ,end: this.lastEnd },
      { label: "Último Ano", start: this.yearStart ,end: this.yearEnd }
    ];
}



